var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabCloseRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1227_4136",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1227_4136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09992 10.7333L7.99992 8.83332L9.89992 10.7333L10.7333 9.89998L8.83325 7.99998L10.7333 6.09998L9.89992 5.26665L7.99992 7.16665L6.09992 5.26665L5.26659 6.09998L7.16659 7.99998L5.26659 9.89998L6.09992 10.7333ZM3.14992 14.4167C2.71603 14.4167 2.34642 14.264 2.04109 13.9588C1.73586 13.6535 1.58325 13.2839 1.58325 12.85V3.14998C1.58325 2.71154 1.73586 2.33804 2.04109 2.02948C2.34642 1.72093 2.71603 1.56665 3.14992 1.56665H12.8499C13.2884 1.56665 13.6619 1.72093 13.9704 2.02948C14.279 2.33804 14.4333 2.71154 14.4333 3.14998V9.94998C14.1758 9.86109 13.9143 9.79998 13.6486 9.76665C13.3828 9.73332 13.1166 9.72776 12.8499 9.74998V3.14998H3.14992V12.85H9.54992C9.50547 13.1167 9.49159 13.3801 9.50825 13.6403C9.52492 13.9004 9.56659 14.1592 9.63325 14.4167H3.14992ZM13.1833 16.0667L12.2499 15.15L13.2999 14.0667H10.5166V12.75H13.2999L12.2499 11.6833L13.1833 10.75L15.8333 13.4167L13.1833 16.0667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabCloseRight);
export default __webpack_public_path__ + "static/media/tab_close_right.4a9b88bb8be62b9046e565c03595adba.svg";
export { ForwardRef as ReactComponent };